import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceActionTypes, serviceInjectionTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupAction = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceActionTypes.ActionLookupDataType): AxiosPromise<serviceActionTypes.ActionLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.action.lookupAction), {
      blockSpinner,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.action.lookupAction), {
    blockSpinner,
  });
};

export const lookupActionTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceActionTypes.ActionLookupDataType): AxiosPromise<serviceActionTypes.ActionTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.action.lookupAction), {
      blockSpinner,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.action.lookupAction), {
    blockSpinner,
  });
};

export const createAction = (
  form: serviceActionTypes.ActionCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceActionTypes.ActionCreateResultType> => {
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.actionNumber) {
    formData.append('actionNumber', form.actionNumber);
  }

  if (form.actionName) {
    formData.append('actionName', form.actionName);
  }

  if (form.scriptedById) {
    formData.append('scriptedById', form.scriptedById);
  }

  if (form.scriptedDateTime) {
    formData.append('scriptedDateTime', form.scriptedDateTime.toString());
  }

  if (form.modifiedById) {
    formData.append('modifiedById', form.modifiedById);
  }

  if (form.modifiedDateTime) {
    formData.append('modifiedDateTime', form.modifiedDateTime.toString());
  }
  if (form.emir && form.emir.length > 0) {
    formData.append('emir', form.emir.join(','));
  }
  if (form.actionCoordinatorId) {
    formData.append('actionCoordinatorId', form.actionCoordinatorId);
  }

  if (form.actors) {
    form.actors.forEach((e) => formData.append('actors', e as any as string));
  }

  if (form.dateTimeGroup) {
    formData.append('dateTimeGroup', form.dateTimeGroup.toString());
  }

  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  if (form.injectionReferenceId) {
    formData.append('injectionReferenceId', form.injectionReferenceId);
  }
  if (form.actionReferenceId) {
    formData.append('actionReferenceId', form.actionReferenceId);
  }
  if (form.duration) {
    formData.append('duration', form.duration);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  // if (form.unitInSimulation) {
  //   formData.append('unitInSimulation', form.unitInSimulation);
  // }
  if (form.units && form.units.length > 0) {
    formData.append('units', form.units.join(','));
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.actionStatusId) {
    formData.append('actionStatusId', form.actionStatusId);
  }
  formData.append('isAnchor', form.isAnchor.toString());

  return axios.post(urlsConfig.action.createAction, formData, { headers: serviceLocals.formDataHeader });
};

export const actionEdit = (
  form: serviceActionTypes.ActionEditDataType,
  // formData: FormData,
): AxiosPromise<serviceActionTypes.ActionEditResultType> => {
  const actorsConvert = fileHelper.convertArrayData(form.actors);
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.actionNumber) {
    formData.append('actionNumber', form.actionNumber);
  }

  if (form.actionName) {
    formData.append('actionName', form.actionName);
  }

  if (form.scriptedById) {
    formData.append('scriptedById', form.scriptedById);
  }

  if (form.scriptedDateTime) {
    formData.append('scriptedDateTime', form.scriptedDateTime.toString());
  }

  if (form.modifiedById) {
    formData.append('modifiedById', form.modifiedById);
  }

  if (form.modifiedDateTime) {
    formData.append('modifiedDateTime', form.modifiedDateTime.toString());
  }
  if (form.emir && form.emir.length > 0) {
    formData.append('emir', form.emir.join(','));
  }
  if (form.actionCoordinatorId) {
    formData.append('actionCoordinatorId', form.actionCoordinatorId);
  }

  if (form.actors) {
    form.actors.forEach((e) => formData.append('actors', e as any as string));

    // formData.append('actors', actorsConvert);
  }

  if (form.dateTimeGroup) {
    formData.append('dateTimeGroup', form.dateTimeGroup.toString());
  }
  //  else {
  //   formData.append('dateTimeGroup', '0');
  // }

  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  if (form.injectionReferenceId) {
    formData.append('injectionReferenceId', form.injectionReferenceId);
  }
  if (form.actionReferenceId) {
    formData.append('actionReferenceId', form.actionReferenceId);
  }

  if (form.duration) {
    formData.append('duration', form.duration);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  // if (form.unitInSimulation) {
  //   formData.append('unitInSimulation', form.unitInSimulation);
  // }
  if (form.units && form.units.length > 0) {
    formData.append('units', form.units.join(','));
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.actionStatusId) {
    formData.append('actionStatusId', form.actionStatusId);
  }
  formData.append('isAnchor', form.isAnchor.toString());

  return axios.patch(urlsConfig.action.actionEdit, formData, { blockErrorHandler: true });
};

export const actionDelete = ({
  id,
}: serviceActionTypes.ActionDeleteDataType): AxiosPromise<serviceActionTypes.ActionDeleteResultType> => {
  return axios.delete(`${urlsConfig.action.actionDelete}/${id}`);
};
